export default {
  entityCount:
    'Listing <b>{count}</b> <b class="text-info capitalize">{entity}s</b> out of <b>{total}</b>',
}
